import {Polyline, Place, Layers} from "@mui/icons-material";
import PentagonOutlinedIcon from '@mui/icons-material/PentagonOutlined';
// import { red, pink, p } from '@mui/material/colors';

export default function getGeometryIcon(type){
    switch (type) {
        case "POINT":
            return <Place fontSize="small" color="primary" />;
        case "LINESTRING":
            return <Polyline fontSize="small" color="primary"/>;
        case "POLYGON":
            return <PentagonOutlinedIcon fontSize="small" color="primary" />;
        default:
            return <Layers fontSize="small" />;
    }
};
